module.exports = __webpack_public_path__ + "img/16m005-02.8d1538e3.jpg";